import { Component, OnInit } from '@angular/core';
import { SharedService } from '../shared.service';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import OComeJson from 'src/assets/outcome/outcomes.json';

//import * as OCData from 'src/assets/outcome/outcomes.json';

interface OutComes {
  outcometype: string;
  title: string;
  subtitle: string;
}


@Component({
  selector: 'app-animaloutcome',
  templateUrl: './animaloutcome.component.html',
  styleUrls: ['./animaloutcome.component.scss']
})

export class AnimaloutcomeComponent implements OnInit{
  animalId: string = '';
  animals: any;
  animalSearchForm!: FormGroup;
  submitted = false;
  hidedetails = false;
  recordNotFound = false;
  errorResponse = false;
  spinnerStatus = false;
  OutcomeArray: any[] = [];
  outcomeTitle: string = '';
  outcomeDesc: string = '';
  url: string = 'src/assets/outcome/outcomes.json';
  data: any[] = [];
  outComes:OutComes[] = OComeJson; 
  inputValue: string = "";
  testurl: string = "";
  //customPatterns: any = 'A': { pattern: new RegExp('[A-Z0-9]') }
  //StatusData: any = OCData;

  constructor(private sharedservice: SharedService, private fb:FormBuilder, private http:HttpClient,) {}

  ngOnInit(){

    this.animalSearchForm = this.fb.group({
      animalId: ['', [Validators.required, 
                     Validators.minLength(8),
                     Validators.maxLength(8),
                     Validators.pattern("^(A)\\d{7}$")]]
    });
        
    fetch (this.url).then(res => res.json())
    .then(jsonData => {
      this.OutcomeArray = jsonData;
    });

    this.http.get('src/assets/outcome/outcomes.json').subscribe((items:any) => {
      console.log(items);
      //console.log(this.StatusData);
      this.data = items.list;
      //this.data = this.StatusData;
    });

    console.log("Length json file"); 
    console.log(this.outComes.length);
  }

  onSubmit(){
    this.submitted = true;
    this.spinnerStatus = false;
    this.recordNotFound = false;
    this.hidedetails = true;
    
    if (this.animalSearchForm.invalid)
    {
      return;
    }
    this.spinnerStatus = true;
    this.getAnimalData(this.animalSearchForm.controls['animalId'].value);
  }

  searchOutcomeType(ctype: any): void
  { 
    console.log(ctype);

    for (let i=0; i < this.outComes.length; i++)
    {
      if (this.outComes[i].outcometype.toUpperCase() == ctype)
      {
          this.outcomeTitle = this.outComes[i].title;
          this.outcomeDesc = this.outComes[i].subtitle;
          break;
      }
    }
  }

  clearInput() {
    this.inputValue = '';
  }

  hideDetails() {
    if (this.inputValue.length != 8)
    {
      this.hidedetails = true;
    }
  }

  getAnimalData(id: string): void {
    
    this.recordNotFound = false;
    this.errorResponse = false;
    this.sharedservice.getAnimals(id)
     .subscribe(response => {
        this.animals = response;
        this.spinnerStatus = false;
        if (this.animals.length < 1)
        {
            this.recordNotFound = true;
            console.log("No record found");
            console.log("Status code: ", this.animals.status.value); 
        }
        else
          if (this.animals.length > 1)
          {
              this.hidedetails = false;
          
          }
            
        if (this.animals.status.value == 400 || this.animals.status.value == 500)
        {
            this.errorResponse = true;
            console.log("Error return from API");
            console.log("Status code: ", this.animals.status.value)
        }
        console.log("Number of record:", this.animals.length);

     });
  }

  checkImage(strImage: string)
  {
    console.log("Pet image: ", strImage);
    if (strImage.trim.length < 1)
    {
      return "./assets/images/ASD_Noimage.jpg'";
    }
    return "data:image/jpeg;base64, "+strImage;
    //return fetch(strImage)
    //          .then (res => {
    //            return res.blob();
     //         });
    
  }

  getOutcomeDesc(strCode: string)
  {
    strCode = strCode.toUpperCase();
    
    console.log(this.OutcomeArray);

    for(let obj of this.OutcomeArray)
    {
      if (obj["outcometype"].toUpperCase().trim() == strCode || obj["outcometype"].trim() == strCode)
      {
        this.outcomeTitle = obj["title"];
        this.outcomeDesc = obj["subtitle"];
        break;
      }
    }
  }
}
